import React from "react"

import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { useAppSelector } from "../../../store/selectors/app.selector"
import { payerMappingsSelector } from "../../../store/selectors/payerMappings.selector"

import plusIcon from "@front-shared/assets/images/icons/plus-white.svg"
import refreshIcon from "@front-shared/assets/images/icons/refresh-dark2.svg"

export const PayerMappingsReviewFloatingControlComponent: React.FunctionComponent<
    IPayerMappingsReviewFloatingControlComponentProps
> = props => {
    const payerMappingsState = useAppSelector(payerMappingsSelector)

    const hasExistingMappings = payerMappingsState.unfilteredItemsTotal > 0

    return (
        <div
            className="
                fixed bottom-[24px] horizontal-center flex items-center z-20
                bg-brand-white rounded-[100px]
                pl-[32px] py-[12px] pr-[12px]
                gap-[8px] min-w-[320px] max-w-[90vw]
                border border-solid border-brand-vibrantPurple
                flex-wrap justify-center
            "
        >
            <div className="flex items-center gap-[8px] flex-shrink-0">
                <span
                    className={`
                        flex-shrink-0 w-[20px] h-[20px] rounded-full flex items-center justify-center text-white text-[12px] font-bold
                        ${props.invalidCount ? "bg-brand-error2" : "bg-brand-green3"}
                    `}
                    aria-hidden
                >
                    {props.invalidCount ? "!" : "✓"}
                </span>

                <PrimaryText
                    typography="text"
                    size={14}
                    className="whitespace-nowrap"
                >
                    <span className="text-bold">
                        {props.invalidCount || props.validCount} of{" "}
                        {props.totalCount} mapping
                        {props.totalCount > 1 ? "s" : ""}
                    </span>{" "}
                    {(props.invalidCount || props.validCount) === 1
                        ? "is"
                        : "are"}{" "}
                    {props.invalidCount ? "invalid" : "valid"}
                </PrimaryText>
            </div>

            <div className="flex items-center gap-[8px] flex-shrink-0">
                <ButtonElement
                    label="Re-upload CSV"
                    htmlType="button"
                    type="default"
                    onClick={props.onReuploadCsv}
                    icon={refreshIcon}
                    buttonClassName="!pl-[16px] !pr-[16px]"
                />

                {props.validCount ? (
                    <>
                        <ButtonElement
                            label={`Add ${props.validCount}`}
                            htmlType="button"
                            type="primary"
                            onClick={props.onAddValidMappings}
                            isLoading={props.isSubmitting}
                            icon={plusIcon}
                            buttonClassName="!pl-[16px] !pr-[16px]"
                        />

                        {hasExistingMappings && (
                            <ButtonElement
                                label={`Replace with ${props.validCount}`}
                                htmlType="button"
                                type="default"
                                onClick={props.onReplaceValidMappings}
                                isLoading={props.isSubmitting}
                                buttonClassName="!pl-[16px] !pr-[16px]"
                            />
                        )}
                    </>
                ) : null}
            </div>
        </div>
    )
}

interface IPayerMappingsReviewFloatingControlComponentProps {
    invalidCount: number
    totalCount: number
    validCount: number
    onReuploadCsv: () => void
    onAddValidMappings: () => void
    onReplaceValidMappings: () => void
    isSubmitting?: boolean
}
